'use strict';

export default class SearchFooter extends React.Component {
    render() {
        return <div className="empty">
            <div className="empty-title">
                {tMsg('Нет подходящего рейса?')}
            </div>
            <div className="empty-btns">
                <a href={`${langPrefix}/request/sharing`} className="button button-transparent">
                    {tMsg('Подайте заявку на Jet Sharing')}
                </a>
                <a href={`${langPrefix}/request/plane`} className="button button-transparent">
                    {tMsg('Запросите цены на Charter')}
                </a>
                <a href={`${langPrefix}/request/emptyleg`} className="button button-transparent">
                    {tMsg('Подпишитесь на Empty Legs')}
                </a>
            </div>
        </div>
    }
}
